<template>
  <div class="Formation">
    <HeadPage :title="'Formation'"
              :img="null"
              :imgAlt="null"
    />
    <div class="Formation-Upper-Text">
      <div class="Formation-Text Text">
        <p><strong>JobStream</strong> propose des actions de formation destinées à <strong>développer les compétences 
          professionnelles, favoriser l'accès à l'emploi et accompagner les évolutions de 
          parcours.</strong>
        </p>
        <p>Notre offre s'adresse aux entreprises, aux salariés et aux personnes en recherche 
          d'emploi, notamment dans les secteurs de l'industrie.
        </p>
        <p>Nous proposons un accompagnement pour une <strong>orientation réussie vers les métiers 
          de l'industrie</strong> (échafaudeur, technicien de maintenance, monteur en isolation 
          thermique, soudeur, tuyauteur, monteur-câbleur en aéronautique, opérateur en 
          pétrochimie, etc...)
        </p>
        <p>Notre équipe reste disponible pour répondre à toute demande d'information, 
          orienter les candidats dans leur recherche de formation et étudier les conditions 
          d'accessibilité des parcours.
        </p>
        <p>Pour les tarifs / devis / informations complémentaires, nous contacter au <a href="tel:0749131971">07 49 13 19 71</a> ou <a href="mailto:contact@jobstream.fr">contact@jobstream.fr</a></p>
      </div>
    </div>
    <Section :title="'Comportements gagnants - soft skills'"
             :content="[
                 `<a style='font-size: 14px; color: #00919B;' href='./files/formation/JS_Formation_ComportementsGagnants.pdf' target='_blank'>
                    Adopter les bons comportements pour s'intégrer durablement dans l'entreprise
                  </a>
                 `
                 ]"
    />
    <Section :title="'Accompagnement vers et dans l\'emploi'"
             :content="[
                 `<a style='font-size: 14px; color: #00919B;' href='./files/formation/JS_Formation_TrajectoiresGagnantes.pdf' target='_blank'>
                    Trajectoire gagnante vers les métiers de l'industrie
                  </a>
                 `,
                 /* `<a style='font-size: 14px; color: #00919B;' href='./files/formation/JS_Formation_AgroAlimentaire.pdf' target='_blank'>
                    Tremplin vers l'industrie agroalimentaire
                  </a>
                 `, */
                 /*`<a style='font-size: 14px; color: #00919B;' href='./files/formation/JS_Formation_RemiseANiveau.pdf' target='_blank'>
                    Remise à niveau - disciplines générales
                  </a>
                 `,*/
                 /* `<a style='font-size: 14px; color: #00919B;' href='/evolution/bilan'>
                    Bilan de compétences
                  </a>`, */
                 /*`<a style='font-size: 14px; color: #00919B;' href='/evolution/validation'>
                    Accompagnement à la Validation des Acquis de l'Expérience (VAE)
                  </a>`,
                  `<a style='font-size: 14px; color: #00919B;' href='./files/formation/JS_Programmes_Parcours_Monteur_polyvalent.pdf' target='_blank'>
                    Horizon Industrie - Monteur Polyvalent
                  </a>`,*/
                  `<a style='font-size: 14px; color: #00919B;' href='./files/formation/JS_Jobstream_Parcours_TGMI.mp4' target='_blank'>
                    Vidéo TGMI
                  </a>`,
                 ]"
    />
    <div class="Formation-Stats">
      <p style="text-decoration: underline #00AEB0;">Les indicateurs de 2025.</p>
      <Stats :stats="[
                { 
                    src: 'global/group.svg',
                    alt:'Icon Group',
                    stat: '152',
                    text: 'Nombre de stagiaires accueillis'
                },
                { 
                    src: 'global/satisfaction.svg', 
                    alt:'Icon Satisfaction',
                    stat: '93%',
                    text: 'Taux satisfaction'
                }
            ]"
      />
    </div>
    <Handicap/>
  </div>
</template>

<script>
/* En attente d'ajout
{ 
  src: 'global/satisfaction2.svg', 
  alt:'Icon Flag',
  stat: '0',
  text: 'Taux de satisfaction des clients'
}, */
import HeadPage from '../global/HeadPage.vue'
import Section from '../global/Section.vue'
import Stats from '../global/Stats.vue'
import Handicap from '../global/Handicap.vue'

export default {
  name: "Formation",
  components: {
    HeadPage,
    Section,
    Stats,
    Handicap
  }
}
</script>

<style scoped>

.Formation >>> .Section {
  max-width: 1100px;
}

/* 
* Text 
*/
.Formation-Upper-Text {
  text-align: left;
  margin: auto;
  max-width: 800px;
  padding: 25px;
}

.Formation-Stats {
  text-align: center;
  padding: 80px;
}

.Formation-Text {
  margin-top: 50px;
  text-align: left;
}

ul {
  padding: 20px 0px 20px 50px;
  list-style-image: url('/img/global/dot.svg');
}

</style>